import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ActivityCode from '@/views/marketing/marketingManage/activityCode/index.vue'


const __default__ = { name: 'DcCosLbuActivityCode' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const permission = {
  add: 'lbu_activity_add_btn',
  edit: 'lbu_activity_edit_btn',
  delete: 'lbu_activity_del_btn',
  enable: 'lbu_activity_enable_btn',
  disable: 'lbu_activity_disable_btn',
  qrcode: 'lbu_activity_qrcode_btn',
  card: 'lbu_activity_card_btn'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ActivityCode, {
    permission: permission,
    subdomain: "lbu",
    paramCode: "zbu_source_channel_lbu"
  }))
}
}

})